"use strict";

Object.defineProperty(exports, "__esModule", {
             value: true
});
var UPDATE_INPUT_VALIDITY = exports.UPDATE_INPUT_VALIDITY = "UPDATE_INPUT_VALIDITY",
    UPDATE_INPUT_GROUP_VALIDITY = exports.UPDATE_INPUT_GROUP_VALIDITY = "UPDATE_INPUT_GROUP_VALIDITY",
    UPDATE_FORM_VALIDITY = exports.UPDATE_FORM_VALIDITY = "UPDATE_FORM_VALIDITY",
    UPDATE_PRISTINE = exports.UPDATE_PRISTINE = "UPDATE_PRISTINE",
    UPDATE_FORM_SUBMITTING = exports.UPDATE_FORM_SUBMITTING = "UPDATE_FORM_SUBMITTING",
    UPDATE_FORM_SUBMITTED = exports.UPDATE_FORM_SUBMITTED = "UPDATE_FORM_SUBMITTED";